import movements from './submodules/movements';
import utils from '@/stores/utils';

const { getStorageKey } = utils;

const state = {

};

const mutations = {

};

const actions = {

    async init({ commit, dispatch, state }, params) {
        dispatch('movements/init', {
            filters: {},
        });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        movements: movements({
            storageKey: getStorageKey('movements', 'default'),
            fieldsToSave: undefined // Save all filters
        }),
    }
};
